import React from 'react';
import Clients from "../../components/Admin/Clients";

const ClientsPage = () => {
  return <Clients />;
};

export default ClientsPage;
